<template>
  <div class="container-fluid py-4">
    <!-- Header clinique -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-door-open fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Création d'une Chambre</h2>
      </div>
      <router-link class="btn btn-primary btn-lg shadow-sm btn-clinique" :to="{ name: 'liste_chambre' }">
        <i class="bi bi-arrow-left-circle me-2"></i> Retour
      </router-link>
    </div>

    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique">
      <div class="row g-4">
        <!-- Numéro de chambre -->
        <div class="col-md-6">
          <label for="numero" class="form-label fw-semibold">Numéro de chambre</label>
          <input
            type="text"
            id="numero"
            v-model="chambre.numero"
            class="form-control form-control-clinique"
            :class="{ 'is-invalid': error.numero }"
            placeholder="Ex : 101"
          >
          <div class="invalid-feedback">{{ error.numero }}</div>
        </div>

        <!-- Type de chambre -->
        <div class="col-md-6">
          <label for="type" class="form-label fw-semibold">Type de chambre</label>
          <select
            id="type"
            v-model="chambre.typeId"
            class="form-select form-select-clinique"
            :class="{ 'is-invalid': error.typeId }"
          >
            <option value="">-- Sélectionner --</option>
            <option v-for="type in typesChambre" :key="type.id" :value="type.id">
              {{ type.nom }}
            </option>
          </select>
          <div class="invalid-feedback">{{ error.typeId }}</div>
        </div>
      </div>

      <!-- Statut -->
      <div class="row g-4 mt-1">
        <div class="col-md-6 d-flex align-items-center">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="enabled" v-model="chambre.isEnabled">
            <label class="form-check-label ms-2 fw-semibold" for="enabled">
              Activé ?
            </label>
          </div>
        </div>
      </div>

      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button class="btn btn-light border shadow-sm px-4 py-2" @click="cancel">
          <i class="bi bi-x-circle me-1"></i> Annuler
        </button>
        <button class="btn btn-success shadow px-4 py-2 btn-clinique" :disabled="isLoading" @click="saveChambre">
          <i class="bi bi-save me-1"></i>
          <span v-if="isLoading">Chargement...</span>
          <span v-else>Enregistrer</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: false,
      typesChambre: [],
      chambre: {
        numero: '',
        typeId: '',
        isEnabled: true
      },
      error: {
        numero: '',
        typeId: ''
      }
    };
  },
  methods: {
    async fetchTypesChambre() {
      try {
        const response = await api.getItems('type_chambres');
        this.typesChambre = response.data.data || [];
      } catch (error) {
        console.error('Erreur lors de la récupération des types de chambre', error);
      }
    },
    validateForm() {
      this.error = {
        numero: this.chambre.numero ? '' : 'Le numéro est requis',
        typeId: this.chambre.typeId ? '' : 'Le type de chambre est requis'
      };
      return !Object.values(this.error).some(err => err !== '');
    },
    async saveChambre() {
      if (!this.validateForm() || this.isLoading) return;
      try {
        this.isLoading = true;
        const payload = {
          numero: this.chambre.numero,
          type: this.chambre.typeId,
          isEnabled: this.chambre.isEnabled
        };
        await api.createItem('chambres', payload);
        //alert('Chambre créée avec succès !');
        this.$router.push({ name: 'liste_chambre' });
      } catch (error) {
        console.error('Erreur lors de la création de la chambre', error);
        alert("Une erreur s'est produite lors de l'enregistrement.");
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$router.push({ name: 'liste_chambre' });
    }
  },
  created() {
    this.fetchTypesChambre();
  }
};
</script>

<style scoped>
/* --- Header clinique --- */
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

/* --- Card formulaire --- */
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

/* --- Champs --- */
.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus,
.form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

/* --- Boutons --- */
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
</style>
